module.exports = __webpack_public_path__ + "fromBrideToFather-jp-r.882d602b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/fromBrideToFather-jp-r.jpg
// module id = rQ5Q
// module chunks = 0